<template>
  <section>
    <el-row>
      <el-col :span="18">
        <el-button size="small" @click="goBack()">
          <i class="el-icon-back"></i>
        </el-button>
        <span class="ml-1" style="font-size: larger; font-weight: bold"
          >Discussion Forums</span
        >
      </el-col>
      <!-- <el-col :span="6">
        <el-input placeholder="Search"> </el-input>
      </el-col> -->
    </el-row>
    <el-row class="mt-2"> </el-row>
    <div v-if="showForbidden">
      <el-empty description="You have not configured any discussion forums">
      </el-empty>
    </div>
    <div v-else>
      <el-row v-loading="loading">
        <el-col :span="15" v-loading="forumsLoading">
          <el-card>
            <el-row>
              <el-tag v-if="hilightedTag" closable @close="removeTag">{{
                hilightedTag
              }}</el-tag>
            </el-row>
            <div v-if="allForums.length">
              <el-row
                v-for="(forum, index) in allForums"
                :key="forum._id"
                class="py-3"
                :style="{
                  borderBottom:
                    index !== allForums.length - 1 ? '1px solid #ccc' : 'none',
                }"
              >
                <el-col :span="24">
                  <div class="d-flex" style="gap: 10px">
                    <div class="icon-block initial" style="margin-top: 2px">
                      <div v-if="entityUserInfoData[forum.created_by]?.avatar">
                        <img
                          :src="entityUserInfoData[forum.created_by].avatar"
                          alt="IMG"
                          width="40"
                          height="40"
                          style="border-radius: 50%"
                        />
                      </div>
                      <div class="icon" v-else>
                        <div class="initial-text">
                          <span>{{ getInitials(forum) }}</span>
                        </div>
                      </div>
                    </div>

                    <div style="flex: 1">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <el-link
                          style="
                            font-size: medium;
                            font-weight: bold;
                            cursor: pointer;
                          "
                          @click="openForum(forum._id)"
                          >{{ forum.title }}</el-link
                        >
                        <el-tag
                          v-if="isNewForum(forum)"
                          type="success"
                          class="ml-2 animated-new-tag"
                          size="small"
                          effect="dark"
                        >
                          New
                        </el-tag>
                        <el-tag
                          v-else-if="getUnreadCount(forum)"
                          class="animated-new-tag"
                          type="danger"
                          size="small"
                          effect="dark"
                          >{{ getUnreadCount(forum) }}</el-tag
                        >
                      </div>

                      <div class="truncate-2-lines" style="margin-top: 6px">
                        <span style="font-size: small">{{
                          extractTextFromHTML(forum.content)
                        }}</span>
                      </div>

                      <div style="margin-top: 6px">
                        <span
                          v-for="tag in forum.tags"
                          :key="tag"
                          style="
                            color: #1890ff;
                            cursor: pointer;
                            margin-right: 6px;
                            font-size: small;
                          "
                          @click="openTag(tag)"
                          >{{ tag }}</span
                        >
                      </div>

                      <div
                        class="mt-1 d-flex justify-content-between align-items-center"
                        style="font-size: small; font-weight: 600"
                      >
                        <div>
                          <span style="border: 1px solid #ccc; padding: 6px">
                            By {{ getCreatedBy(forum) }}
                          </span>
                          <span
                            class="date-time text-dark fw-medium opacity-50 ml-2"
                          >
                            {{ forum.created_at | getFormattedDateTypeThree }}
                          </span>
                        </div>
                        <div
                          class="d-flex align-items-center"
                          style="gap: 20px; font-size: small; font-weight: 500"
                        >
                          <div
                            class="d-flex align-items-center"
                            style="gap: 5px; cursor: pointer"
                          >
                            <img
                              v-if="
                                forum.liked_by.includes(
                                  getAuthenticatedUser._id
                                )
                              "
                              width="20"
                              height="20"
                              src="../../../public/assets/img/icons/Like - Fill.svg"
                              @click="dislike(index)"
                            />
                            <img
                              v-else
                              width="20"
                              height="20"
                              src="../../../public/assets/img/icons/Like - Outline.svg"
                              @click="like(index)"
                            />
                            <span>{{ forum.liked_by.length }}</span>
                          </div>
                          <div
                            style="
                              width: 1px;
                              height: 20px;
                              background-color: #ccc;
                              align-self: stretch;
                            "
                          ></div>
                          <div
                            class="d-flex align-items-center"
                            style="gap: 5px"
                          >
                            <img
                              src="../../../public/assets/img/icons/Comment.svg"
                              width="20"
                              height="18"
                            />
                            <span>{{ forum.comments.length }}</span>
                          </div>
                          <div
                            style="
                              width: 1px;
                              height: 20px;
                              background-color: #ccc;
                              align-self: stretch;
                            "
                          ></div>
                          <div
                            class="d-flex align-items-center"
                            style="gap: 5px"
                          >
                            <i class="el-icon-view"></i>
                            <span>{{ forum.read_by.length }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row
                v-if="hasMore"
                style="
                  align-items: center;
                  justify-content: center;
                  display: flex;
                "
              >
                <span class="tag-name" @click="loadMore">{{
                  showMoreLoading ? "Fetching..." : "Show more activity"
                }}</span>
              </el-row>
            </div>
            <div v-else>
              <el-empty> </el-empty>
            </div>
          </el-card>
        </el-col>
        <el-col :span="9">
          <div class="container">
            <el-row justify="center" class="ask-button-row">
              <el-button
                type="primary"
                style="width: 100%"
                @click="askNewQuestion"
                >Ask your question</el-button
              >
            </el-row>
            <div class="tag-box">
              <div class="tag-header">
                <i class="el-icon-collection-tag"></i>
                <span>Tags</span>
              </div>
              <div v-for="tag in tags" :key="tag._id" class="tag-row">
                <div class="tag-name" @click="openTag(tag._id)">
                  {{ tag._id }}
                </div>
                <el-tag size="small">{{ tag.count }}</el-tag>
              </div>
            </div>

            <div class="tag-box mt-2">
              <div class="tag-header">
                <i class="el-icon-collection-tag"></i>
                <span>Most Discussed Topics</span>
              </div>
              <div v-for="topic in topics" :key="topic._id" class="tag-row">
                <div style="cursor: pointer" @click="openForum(topic._id)">
                  {{ topic.title }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { postAPICall } from "../../helpers/httpHelper";
export default {
  data() {
    return {
      allForums: [],
      entityUserInfoData: {},
      tags: [],
      topics: [],
      page: 1,
      limit: 10,
      url: "",
      hasMore: false,
      loading: false,
      forumsLoading: false,
      hilightedTag: "",
      showMoreLoading: false,
      payload: null,
      showForbidden: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser", "getActiveContactType"]),
    ...mapGetters("menuManagementV2", ["getEntityMenu"]),
    ...mapGetters("applicationUsersPermission", ["getEntityPermission"]),
    isApplicationUser() {
      return this.$route.name == "ApplicationUserAllForums" ? true : false;
    },
  },
  async mounted() {
    await this.getNecessaryInfo();
  },
  methods: {
    async getNecessaryInfo() {
      this.loading = true;
      this.showForbidden = false;
      let entities_list = [];
      let menu;
      let entityId = this.$route?.query?.entity_id?.includes("@") ? this.$route.query.entity_id.split("@")[0] : this.$route.query.entity_id;
      let params = {};
      if (this.isApplicationUser) {
        let id = this.$route.query.menu_id;
        if (id) {
          this.getEntityMenu.menu_list.forEach((e) => {
            if (e._id == id) {
              menu = e;
            } else if (e.children) {
              (e.children || []).forEach((el) => {
                if (el._id == id) {
                  menu = el;
                } else if (el.children) {
                  (el.children || []).forEach((ele) => {
                    if (ele._id == id) {
                      menu = ele;
                    }
                  });
                }
              });
            }
          });
          if (menu.forum_entities) {
            entities_list = menu.forum_entities;
          }
        } else if (
          entityId &&
          this.$route.query.entity_data_id
        ) {
          if (
            this.getEntityPermission?.relational_entities &&
            Object.keys(this.getEntityPermission.relational_entities).includes(
              entityId
            )
          ) {
            let response = await postAPICall(
              "POST",
              "/entities-data/entity/data/v2",
              {
                entity_id: entityId,
                entity_data_ids: [this.$route.query.entity_data_id],
                template_fields_data : [],
                filters: [
                  {
                    field: "self#related_to/1",
                    operator: "=",
                    value: this.getActiveContactType.account_data_id,
                    value_type: "",
                    value_source: "",
                    query_type: "AND",
                    value_field: "",
                    validations: {
                      data_type: "",
                    },
                    nested_related_id: "",
                    data_source: "self_field",
                    relation_entity_id:
                      this.getActiveContactType.contact_type._id,
                    data_type: "RELATION",
                  },
                ],
              }
            );
            if (!response.data.data.length) {
              this.showForbidden = true;
              return;
            }
          } else if (
            !this.getEntityPermission.other_entities ||
            !Object.keys(this.getEntityPermission.other_entities).includes(
              entityId
            )
          ) {
            this.showForbidden = true;
            return;
          }
        } else {
          this.showForbidden = true;
          return;
        }
      }
      if (entities_list.length) {
        this.payload = entities_list.map((e) => {
          if (e.includes("@") && e.split("@")[1] == "RELATIONSHIP") {
            return {
              entity_id: e.split("@")[0],
              filters: [
                {
                  field: "self#related_to/1",
                  operator: "=",
                  value: this.getActiveContactType.account_data_id,
                  value_type: "",
                  value_source: "",
                  query_type: "AND",
                  value_field: "",
                  validations: {
                    data_type: "",
                  },
                  nested_related_id: "",
                  data_source: "self_field",
                  relation_entity_id:
                    this.getActiveContactType.contact_type._id,
                  data_type: "RELATION",
                },
              ],
            };
          } else {
            return {
              entity_id: e,
              filters: [],
            };
          }
        });
      }
      params.data = this.payload;
      let entityDataId = this.$route.query.entity_data_id;
      if (this.$route.query.tag) {
        this.hilightedTag = decodeURIComponent(this.$route.query.tag);
      }
      if (entityDataId && entityId) {
        this.url = `/forums/get-threads-by-entity-data/${entityId}/${entityDataId}`;
      } else if (entityId) {
        this.url = "/forums/get-threads-by-entity/" + entityId;
      } else {
        this.url = "/forums/get-all-threads";
      }
      let query = `?page=${this.page}&limit=${this.limit}`;
      if (this.hilightedTag) {
        query += `&tag=${encodeURIComponent(this.hilightedTag)}`;
      }
      let [response, tags, topics] = await Promise.all([
        postAPICall("POST", this.url + query, params),
        postAPICall("POST", "/forums/most-used-tags", params),
        postAPICall("POST", "/forums/most-discussed-threads", params),
      ]);
      this.tags = tags.data;
      this.topics = topics.data;
      if (response.data.length) {
        this.hasMore = response.hasMore;
        this.allForums = [...this.allForums, ...response.data];
        await this.fetchUsersInfo(response.data);
      }
      this.loading = false;
    },
    askNewQuestion() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      delete query.tag;
      let path = this.isApplicationUser ? "/ap/create-forum" : "/create-forum";
      this.$router.push({ path, query });
    },
    openForum(id) {
      let path = this.isApplicationUser ? `/ap/forum/${id}` : `/forum/${id}`;
      let query = this.isApplicationUser
        ? {
            menu_id: this.$route.query.menu_id,
          }
        : {};
      this.$router.push({
        path,
        query,
      });
    },
    async fetchUsersInfo(data) {
      let usersInfo = data.map((forum) => forum.created_by);
      let usersResponse = await postAPICall(
        "POST",
        "/entities-data/users-info",
        {
          contact_ids: usersInfo,
          user_ids: usersInfo,
        }
      );
      this.entityUserInfoData = {
        ...this.entityUserInfoData,
        ...usersResponse.data,
      };
    },
    async loadMore() {
      this.showMoreLoading = true;
      this.page++;
      let query = `?page=${this.page}&limit=${this.limit}`;
      if (this.hilightedTag) {
        query += `&tag=${encodeURIComponent(this.hilightedTag)}`;
      }
      let response = await postAPICall("POST", this.url + query, this.payload);
      if (response.data.length) {
        this.hasMore = response.hasMore;
        this.allForums = [...this.allForums, ...response.data];
        await this.fetchUsersInfo(response.data);
      }
      this.showMoreLoading = false;
    },
    async openTag(tag) {
      this.forumsLoading = true;
      this.$router.push({
        path: "/forums",
        query: {
          ...this.$route.query,
          tag: encodeURIComponent(tag),
        },
      });
      this.hilightedTag = tag;
      this.page = 1;
      let query = `?page=${this.page}&limit=${this.limit}`;
      if (this.hilightedTag) {
        query += `&tag=${encodeURIComponent(this.hilightedTag)}`;
      }
      this.allForums = [];
      let response = await postAPICall("POST", this.url + query, this.payload);
      if (response.data.length) {
        this.hasMore = response.hasMore;
        this.allForums = [...this.allForums, ...response.data];
        await this.fetchUsersInfo(response.data);
      }
      this.forumsLoading = false;
    },
    async removeTag() {
      this.forumsLoading = true;
      let query = JSON.parse(JSON.stringify(this.$route.query));
      delete query.tag;
      this.$router.push({
        path: "/forums",
        query,
      });
      this.hilightedTag = "";
      this.page = 1;
      let routeQuery = `?page=${this.page}&limit=${this.limit}`;
      this.allForums = [];
      let response = await postAPICall("POST", this.url + routeQuery, this.payload);
      if (response.data.length) {
        this.hasMore = response.hasMore;
        this.allForums = [...this.allForums, ...response.data];
        await this.fetchUsersInfo(response.data);
      }
      this.forumsLoading = false;
    },
    getInitials(forum) {
      let user = this.entityUserInfoData[forum.created_by];
      return (
        user?.first_name?.charAt(0)?.toUpperCase() +
        user?.last_name?.charAt(0)?.toUpperCase()
      );
    },
    getCreatedBy(forum) {
      if (forum.created_by == this.getAuthenticatedUser._id) {
        return "You";
      }
      let user = this.entityUserInfoData[forum.created_by];
      return user?.first_name + " " + user?.last_name;
    },
    isNewForum(forum) {
      if (
        this.getAuthenticatedUser._id != forum.created_by &&
        !forum.read_by.includes(this.getAuthenticatedUser._id)
      ) {
        return true;
      }
      return false;
    },
    async like(index) {
      const response = await postAPICall(
        "POST",
        "/forums/like-thread/" + this.allForums[index]._id
      );
      if (response.success) {
        this.allForums[index].liked_by.push(this.getAuthenticatedUser._id);
      } else {
        this.$message.error("Something went wrong !");
      }
    },
    async dislike(index) {
      const response = await postAPICall(
        "POST",
        "/forums/dislike-thread/" + this.allForums[index]._id
      );
      if (response.success) {
        this.allForums[index].liked_by.splice(
          this.allForums[index].liked_by.indexOf(this.getAuthenticatedUser._id),
          1
        );
      } else {
        this.$message.error("Something went wrong !");
      }
    },
    extractTextFromHTML(htmlString) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
    getUnreadCount(forum) {
      return (
        forum?.comments.filter(
          (c) =>
            c.created_by != this.getAuthenticatedUser._id &&
            !c?.read_by?.includes(this.getAuthenticatedUser._id)
        )?.length || 0
      );
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  watch : {
    async "$route.query.menu_id" () {
      console.log("entered");
      await this.getNecessaryInfo();
    } 
  }
};
</script>
<style>
.truncate-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.animated-new-tag {
  animation: pulseTag 1.5s infinite ease-in-out;
}

@keyframes pulseTag {
  0%,
  100% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
}

.initial {
  grid-template-columns: 35px auto;
  margin-top: 3px;
  margin-bottom: 3px;

  .icon {
    border: 1px solid #ffa9a9;
    text-align: center;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    padding: 5px;
    background-color: #f1494910;

    .initial-text {
      font-size: 1.2em;
      font-weight: 470;

      span {
        color: #f14949;
      }
    }
  }
}
.container {
  width: 330px;
  margin: 0 auto;
}

.ask-button-row {
  justify-content: center;
  margin-bottom: 16px;
}

.tag-box {
  border: 1px solid #e0e0e0;
  padding: 12px;
  border-radius: 4px;
  background-color: #fff;
}

.tag-header {
  font-weight: 600;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

.tag-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-top: 1px solid #f0f0f0;
  font-size: 14px;
}

.tag-name {
  color: #1890ff;
  cursor: pointer;
}
</style>
